 
import { Spinner } from 'react-bootstrap';
import type { AgGridLoadingParams } from './types';

const AgGridLoading = (props: AgGridLoadingParams) => {
  return (
    <div
      className="ag-custom-loading-cell w-100 d-flex align-items-center gap-2 justify-content-center"
      style={{ paddingLeft: '10px', lineHeight: '25px' }}
    >
      {props.node.failedLoad ? (
        'خطای غیرمنتظره رخ داد، لطفا همین صفحه رو یکبار بارگذاری کنید ، کماکان اگر مشکل داشتید با پشتیبان در تماس باشید.'
      ) : (
        <>
          <Spinner
            animation="border"
            style={{
              width: '18px',
              marginBottom: '-3px',
              paddingLeft: '3px',
              height: '18px'
            }}
          />
          <span> {props.loadingMessage}</span>
        </>
      )}
    </div>
  );
};

export default AgGridLoading;
